import type { JSX } from 'react'
import type { ILabelProps } from '../Label'

import { Label } from '../Label'
import { Backgrounds, Corners, Paddings } from '../Label.h'

export interface ILabelSecondaryRoundedSmallTemplateProps extends ILabelProps {}

export const LabelSecondaryRoundedSmallTemplate = ({
  title = '',
  background = Backgrounds.SURFACE_OPACITY_LIGHT_10,
  corners = Corners.CORNERS_30,
  padding = Paddings.SIZE_10,
  ...rest
}: ILabelSecondaryRoundedSmallTemplateProps): JSX.Element => (
  <Label
    title={title}
    background={background}
    corners={corners}
    padding={padding}
    {...rest}
  />
)
